<template>
  <div id="app">
    <popUp />
    <!-- <mainMenu /> -->
    <router-view />
    <redirect />
  </div>
</template>

<script>
// import mainMenu from '@/components/mainMenu.vue'
import popUp from '@/components/popUp.vue'
import redirect from '@/components/redirectRoute.vue'

export default {
  components: {
    popUp,
    // mainMenu,
    redirect
  },
  mounted() {
    this.getIsLogIn();
  },
  // updated() {
  //   this.isNotLoginRedirect();
  // },
  methods: {
    isNotLoginRedirect(authorize) {
      // console.log("11111111111 " + this.$store.getters.AUTHORIZE);
      if (!authorize
        && !this.$store.getters.AUTHORIZE
        && this.$route.path != "/"
        && this.$route.name != "login"
        && this.$route.path != "/account/registration"
        && this.$route.name != "accountRegistration"
        && this.$route.path != "/account/recovery"
        && this.$route.name != "accountRecovery"
        // && this.$route.path != "/account/save"
        && this.$route.name != "accountSave"
        && this.$route.path != "/404"
        && this.$route.name != "NotFound"
      ) {
        this.$router.push('/');
      }
      if (authorize && this.$route.path === "/") {
        this.$router.push('/personalcabinet');
      }
      // } else if (this.$route.path != "") {
      //   this.$router.push(this.$route.path);
      // }

    },
    getIsLogIn() {
      this.axios
        .get(this.$store.getters.URL + '/account/islogin')
        .then(response => (
          this.$store.commit('authorize', response.data.authorize),
          this.isNotLoginRedirect(response.data.authorize)
        ));
    },
  },
  watch: {
    $route: {
      handler: function () {
        this.getIsLogIn();
      },
      deep: true
    }
  }
}
</script>

<style>
@font-face {
  font-family: 'Roboto Condensed';
  src: url('~@/assets/fonts/RobotoCondensed-Regular.woff2') format('woff2'),
    url('~@/assets/fonts/RobotoCondensed-Regular.woff') format('woff');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}



#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  /* color: #094581; */
  font-size: 22px;
  top: -30px;
}

#app a {
  text-decoration: none;
}

h1,
h2,
h3,
h4,
h5 {
  font-family: 'Roboto Condensed', sans-serif;
  font-weight: 300;
}

#app .form-control {
  margin-top: 10px;
}


#app .btn-primary {
  --bs-btn-bg: #48015a;
  --bs-btn-border-color: #48015a;
  --bs-btn-hover-bg: #6a0583;
  --bs-btn-hover-border-color: #6a0583;
  --bs-btn-active-bg: #6a0583;
  --bs-btn-active-border-color: #6a0583;
  --bs-btn-disabled-bg: #714c7a;
  --bs-btn-disabled-border-color: #714c7a;
}

#app .btn {
  --bs-btn-padding-x: 2rem;
}

#app .btn-outline-primary {
  --bs-btn-color: #6a0583;
  --bs-btn-border-color: #6a0583;
  --bs-btn-hover-bg: #6a0583;
  --bs-btn-hover-border-color: #6a0583;
  --bs-btn-active-bg: #6a0583;
  --bs-btn-active-border-color: #6a0583;
  --bs-btn-disabled-color: #6a0583;
  --bs-btn-disabled-border-color: #6a0583;
}

.bg_account {
  background: url('assets/header-bg1-blur.jpg');
  background-size: cover;
  background-attachment: fixed;
  background-position-x: right;
  min-height: 100vh;

}

.collapse .show {
  background-color: #fff;
}

.go-back {
  width: 120px;
  cursor: pointer;
  transition: all 0.3s ease-out;
}

.go-back:hover {
  color: #6a0583;
  cursor: pointer;
  margin-left: 15px;
}

.go-back:hover::before {
  content: '<-- ';
}

::-moz-selection {
  color: #fff;
  background: #7e5a88;
  text-shadow: none
}

::selection {
  color: #fff;
  background: #7e5a88;
  text-shadow: none
}
</style>
